namespace $.$$ {

	export class $shm_hitalama_domain_page extends $.$shm_hitalama_domain_page {
		
		@ $mol_action
		domain_grab( next?: any ) {
			const domain = $giper_baza_glob.land_grab( [[ null, $giper_baza_rank_read ]] ).Data( $shm_hitalama_domain )
			this.domain_link( domain.link().toString() )
		}

		profiles_grab( next?: any ) {
			const profiles = $giper_baza_glob.land_grab( [[ null, $giper_baza_rank_make( 'post', 'just' ) ]] ).Data( $shm_hitalama_profile_dict )
			$shm_hitalama_domain.instance().Profiles(null)?.remote( profiles )
		}

		template_map_reset( kind: 'js' | 'tsx' | 'sql' | 'commands' ) {
			const profile = this.$.$shm_hitalama_profile.current()
			if( !profile ) return

			switch( kind ) {
				case 'js':
					profile.Templates_js(null)?.remote( null )
					return
				case 'tsx':
					profile.Templates_tsx(null)?.remote( null )
					return
				case 'sql':
					profile.Templates_sql(null)?.remote( null )
					return
				case 'commands':
					profile.Templates_commands(null)?.remote( null )
					return
			}
		}

		templates_js_reset( next?: any ) {
			this.template_map_reset( 'js' )
		}

		templates_tsx_reset( next?: any ) {
			this.template_map_reset( 'tsx' )
		}

		templates_sql_reset( next?: any ) {
			this.template_map_reset( 'sql' )
		}

		templates_commands_reset( next?: any ) {
			this.template_map_reset( 'commands' )
		}

		template_projects_reset( next?: any ) {
			this.$.$shm_hitalama_domain.instance().Projects_map(null)?.remote( null )
			this.$.$mol_state_arg.value( 'projects_map', null )
		}

		@ $mol_mem
		domain_link( next?: string ): string {
			const a = this.$.$shm_hitalama_domain.domain_link( next )
			return $shm_hitalama_domain.domain_link( next )
		}

		profiles_link(): string {
			return $shm_hitalama_domain.instance().Profiles()?.remote()?.link().toString() ?? ''
		}

		domain_can_change(): string {
			return String($shm_hitalama_domain.instance().can_change())
		}
		profiles_can_change(): string {
			return String($shm_hitalama_domain.instance().Profiles()?.remote()?.can_change())
		}

		profile_keys(): string {
			return ($shm_hitalama_domain.instance().Profiles()?.remote()?.keys() ?? []).join('\n')
		}

		current_map_link(): string {
			return this.$.$mol_state_arg.value( 'map' ) ?? ''
		}

		@ $mol_mem
		current_map(): $shm_hitalama_map {
			const link = this.current_map_link()
			if( !link ) return null as any

			return $giper_baza_glob.Pawn( new $giper_baza_link( link ), $shm_hitalama_map )
		}

		current_map_version(): string {
			return String( this.current_map()?.version() ?? '-' )
		}

		current_map_latest_version(): string {
			return String( $shm_hitalama_map_migration.latest_version() )
		}

		current_map_reupdate() {
			const map = this.current_map()
			if( !map ) return

			const prev_version = $shm_hitalama_map_migration.migrations().at( -2 )?.version ?? 0
			map.version( prev_version )
			$shm_hitalama_map_migration.migrate( map )
		}

		Current_map_widgets3_visible() {
			return []
			return this.current_map() ? super.Current_map_widgets3_visible() : []
		}

		Current_map_widgets3_map_page() {
			const map = this.current_map()
			if( !map ) return super.Current_map_widgets3_map_page()

			const map_id = map.link().str
			return this.$.$shm_hitalama_app.Root(0).Maps().Book( map_id ).Map_page()
		}

		static baza_url( next?: string ) {
			return this.$.$mol_state_local.value( '$' + 'hitalama_domain_page_baza_url', next ) ?? 'https://baza.crus.51-250-36-140.ip.hyoo.ru'
		}

		static agent_domain_default() {
			return $shm_hitalama_agent_endpoint.agent_domain_default()
		}

		static online_agent( next?: boolean ) {
			return $shm_hitalama_agent_endpoint.online_agent( next )
		}

		static agent_domain_suffix() {
			return $shm_hitalama_agent_endpoint.agent_domain_suffix()
		}

		static agent_url( subdomain: string, local: string ) {
			return $shm_hitalama_agent_endpoint.agent_url( subdomain, local )
		}

		static agent_preview_url( path: string ) {
			return $shm_hitalama_agent_endpoint.agent_preview_url( path )
		}
		
		@ $mol_mem
		baza_url( next?: string ) {
			return $shm_hitalama_domain_page.baza_url( next )
		}

		@ $mol_mem
		online( next?: boolean ) {
			return this.$.$mol_state_local.value< boolean >( '$' + 'hitalama_domain_page_online', next ) ?? false
		}

		@ $mol_mem
		online_agent( next?: boolean ) {
			return $shm_hitalama_domain_page.online_agent( next )
		}

		@ $mol_mem
		overlayed_map_id(next?: string) {
			return this.$.$mol_state_local.value( 'overlayed_map',next )! ?? ''
		}
		@ $mol_mem
		overlayed_map_enabled( next?: boolean ) {
			const profile = this.$.$shm_hitalama_profile.current()
			if( profile ) return profile.overlayed_map_enabled( next )
			return this.$.$mol_state_local.value< boolean >( 'overlayed_map_enabled', next ) ?? false
		}
		@ $mol_mem
		running_fiber_visible( next?: boolean ) {
			return this.$.$mol_state_local.value< boolean >( 'running_fiber_visible', next ) ?? false
		}

	}
}
